import { render, staticRenderFns } from "./delszjd.vue?vue&type=template&id=3ffbc530&scoped=true&"
import script from "./delszjd.vue?vue&type=script&lang=js&"
export * from "./delszjd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffbc530",
  null
  
)

export default component.exports